/*
 * Click-to-play for YouTube videos pasted into page and article content.
 *
 * main-page / main-article rename the embeds' src to data-bb-yt-src, so the
 * player (~1 MB of YouTube JS) never loads until a shopper asks for it. This
 * swaps each one for a thumbnail button and restores the iframe, autoplaying,
 * on click. It also keeps YouTube's own player markup - which fails several
 * axe rules we can't fix - out of the page until then.
 */
(function () {
  'use strict';

  var PLAY_ICON =
    'data:image/svg+xml,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68 48">' +
        '<path d="M66.5 7.7a8.6 8.6 0 0 0-6-6C55.2.2 34 .2 34 .2s-21.2 0-26.5 1.5a8.6 8.6 0 0 0-6 6C0 13 0 24 0 24s0 11 1.5 16.3a8.6 8.6 0 0 0 6 6C12.8 47.8 34 47.8 34 47.8s21.2 0 26.5-1.5a8.6 8.6 0 0 0 6-6C68 35 68 24 68 24s0-11-1.5-16.3z" fill="#e00"/>' +
        '<path d="M45 24 27 14v20z" fill="#fff"/>' +
        '</svg>'
    );

  var CSS =
    '.bb-yt-facade{position:relative;display:block;width:100%;margin:0 auto 16px;padding:0;' +
    'border:0;background:#000;cursor:pointer;overflow:hidden}' +
    '.bb-yt-facade img{display:block;width:100%;height:100%;object-fit:cover}' +
    '.bb-yt-facade__play{position:absolute;top:50%;left:50%;width:68px;height:48px;' +
    'transform:translate(-50%,-50%);background:url("' +
    PLAY_ICON +
    '") center/contain no-repeat;opacity:.9;transition:opacity .2s}' +
    '.bb-yt-facade:hover .bb-yt-facade__play,.bb-yt-facade:focus-visible .bb-yt-facade__play{opacity:1}' +
    '.bb-yt-facade:focus-visible{outline:3px solid #1a5fb4;outline-offset:3px}';

  var YOUTUBE_HOSTS = /^(www\.|m\.)?youtube(-nocookie)?\.com$/i;

  function isYouTubeEmbed(src) {
    try {
      var url = new URL(src);
      return YOUTUBE_HOSTS.test(url.hostname) && url.pathname.indexOf('/embed/') === 0;
    } catch (e) {
      return false;
    }
  }

  function videoId(src) {
    var m = src.match(/\/embed\/([\w-]{6,})/);
    return m ? m[1] : null;
  }

  function pixels(value) {
    var m = /^\s*(\d+(?:\.\d+)?)\s*(px)?\s*$/i.exec(value || '');
    return m ? parseFloat(m[1]) : null;
  }

  function play(iframe, src, button) {
    var allow = iframe.getAttribute('allow') || '';
    if (!/autoplay/.test(allow)) {
      iframe.setAttribute('allow', (allow ? allow + '; ' : '') + 'autoplay');
    }
    iframe.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    iframe.removeAttribute('data-bb-yt-src');
    button.replaceWith(iframe);
    iframe.focus();
  }

  function facade(iframe) {
    // The snippet keeps the URL as written; load it over https (an http://
    // iframe is blocked as mixed content, and // needs a scheme to be safe).
    var src = iframe
      .getAttribute('data-bb-yt-src')
      .trim()
      .replace(/^(https?:)?\/\//i, 'https://');
    var id = isYouTubeEmbed(src) ? videoId(src) : null;
    if (!id) {
      // Not a recognisable embed URL - just load it as it was.
      iframe.src = src;
      return;
    }
    // Only plain pixel sizes cap the width / set the shape; percentage sizes
    // (width="100%") keep full width at YouTube's 16:9.
    var width = pixels(iframe.getAttribute('width'));
    var height = pixels(iframe.getAttribute('height'));
    var title = (iframe.getAttribute('title') || '').trim();
    var label = title && !/^youtube video player$/i.test(title) ? title : 'YouTube video';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bb-yt-facade';
    button.setAttribute('aria-label', 'Play video: ' + label);
    if (width) button.style.maxWidth = width + 'px';
    button.style.aspectRatio = width && height ? width + ' / ' + height : '16 / 9';

    var img = document.createElement('img');
    img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    img.alt = '';
    img.loading = 'lazy';
    img.width = 480;
    img.height = 360;

    var icon = document.createElement('span');
    icon.className = 'bb-yt-facade__play';
    icon.setAttribute('aria-hidden', 'true');

    button.appendChild(img);
    button.appendChild(icon);
    button.addEventListener('click', function () {
      play(iframe, src, button);
    });
    iframe.replaceWith(button);
  }

  function init() {
    var iframes = document.querySelectorAll('iframe[data-bb-yt-src]');
    if (!iframes.length) return;
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
    iframes.forEach(facade);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
